// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: "/auth",
  DASHBOARD: "/dashboard",
  USER: "/users",
  REPORTEDUSER: "reported-users",
  POST: "/posts",
  REEL: "/reels",
  REPORTEDPOST: "reported-posts",
  REPORTEDREEL: "reported-reels",
  FEEDBACK: "/feedbacks",
  CHANGE_PASSWORD: "change-password",
  OPENCALL: "/opencall",
  OPENCALL_DETAILS: (ocid: string | number) => `/opencall/${ocid}`,
  OPENCALL_AUDITIONS: (ocid: string | number) => `/opencall/auditions/${ocid}`,
  REPORTEDAUDITION: "reported-auditions",
  LIVE: "live",
  STAR_FEED: "/star-feed",
  FEATUREPERMISSION: "feature-permissions",
};

// ----------------------------------------------------------------------

export const paths = {
  auth: {
    jwt: {
      signIn: `login`,
    },
  },
  dashboard: {
    root: ROOTS.DASHBOARD,
    user: ROOTS.USER,
    reportedUser: ROOTS.REPORTEDUSER,
    post: ROOTS.POST,
    reel: ROOTS.REEL,
    reportedPost: ROOTS.REPORTEDPOST,
    reportedReel: ROOTS.REPORTEDREEL,
    feedback: ROOTS.FEEDBACK,
    changePassword: ROOTS.CHANGE_PASSWORD,
    openCall: ROOTS.OPENCALL,
    openCallDetails: ROOTS.OPENCALL_DETAILS,
    openCallAuditions: ROOTS.OPENCALL_AUDITIONS,
    reportedAudition: ROOTS.REPORTEDAUDITION,
    live: ROOTS.LIVE,
    starFeed: ROOTS.STAR_FEED,
    features: ROOTS.FEATUREPERMISSION,
  },
};
